<template>
    <el-container class="welcome-shell">
        <el-header>
            <div class="header-inner">
                <router-link to="/welcome" style="text-decoration: none">
                    <div class="brand-link">
                        <img
                            class="brand-logo"
                            src="../assets/deyunce.jpg"
                        />
                        德云测影院网
                    </div>
                </router-link>
                <el-menu
                    :default-active="activeUrl"
                    class="nav-menu"
                    mode="horizontal"
                    :router="true"
                    active-text-color="red"
                    text-color="#000000"
                >
                    <el-menu-item
                        :index="item.path"
                        v-for="item in menuList"
                        :key="item.id"
                        >{{ item.name }}</el-menu-item
                    >
                </el-menu>
                <div class="searchContainer">
                    <el-input
                        v-model="kw"
                        class="searchBar"
                        placeholder="搜索电影"
                    ></el-input>
                    <el-button
                        id="searchBtn"
                        type="danger"
                        circle
                        @click="search"
                    >
                      <i class="iconfont icon-r-find" style="font-size: 18px;"></i>
                    </el-button>
                </div>
                <el-dropdown trigger="click" @command="handleCommand" class="user-dropdown">
                    <span class="el-dropdown-link">
                        <el-avatar :src="url == '' ? require('@/assets/deyunce.jpg') : url" :size="50">{{
                            url === "" || url === null ? "user" : ""
                        }}</el-avatar>
                        <i
                            class="el-icon-arrow-down el-icon--right icon-arrow"
                        ></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="userMenu" v-if="isToken"
                            >个人中心</el-dropdown-item
                        >
                        <el-dropdown-item command="logout" v-if="isToken"
                            >退出</el-dropdown-item
                        >
                        <el-dropdown-item command="login" v-if="!isToken"
                            >登录</el-dropdown-item
                        >
                        <el-dropdown-item command="register" v-if="!isToken"
                            >注册账号</el-dropdown-item
                        >
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </el-header>
        <el-main>
            <router-view></router-view>
        </el-main>
        <el-footer>
            <div class="footer-mini"></div>
            <div class="footer" style="padding-bottom: 15px">
                <!-- Copyright©忧伤大白兔 -->
            </div>
            <el-backtop></el-backtop>
        </el-footer>
    </el-container>
</template>

<script>
export default {
    name: "Welcome",
    data() {
        return {
            isToken: "",
            cinemaInfo: "",
            url: "",
            activeUrl: this.$route.path.substring(
                0,
                this.$route.path.indexOf("/", 1) === -1
                    ? this.$route.path.length
                    : this.$route.path.indexOf("/", 1)
            ),
            menuList: [
                {
                    id: 1,
                    name: "首页",
                    path: "/home",
                },
                {
                    id: 2,
                    name: "影片",
                    path: "/movie",
                },
                {
                    id: 3,
                    name: "榜单",
                    path: "/rankingList",
                },
                {
                    id: 4,
                    name: "关于",
                    path: "/aboutUs",
                },
            ],
            //搜索关键字
            kw: "",
        };
    },
    created() {
        this.getCinemaInfo();
        this.isToken = window.sessionStorage.getItem("token");
        var res = JSON.parse(
            window.sessionStorage.getItem("loginUser")
        )
        if(res == undefined) {
            return;
        }
        const userPicture = res.userPicture;
        const picture = JSON.parse(userPicture);
        if (picture === null || picture.length === 0) return;
        this.url = this.global.base + picture[0];
    },
    watch: {
        $route() {
            this.activeUrl = this.$route.path.substring(
                0,
                this.$route.path.indexOf("/", 1) === -1
                    ? this.$route.path.length
                    : this.$route.path.indexOf("/", 1)
            );
        },
    },
    methods: {
        async getCinemaInfo() {
            const _this = this;
            await axios
                .get("sysCinema")
                .then((resp) => {
                    if(resp == undefined) {
                        return;
                    }
                    _this.cinemaInfo = resp.data.data;
                })
                .catch((e) => {
                    console.log(e);
                    if (
                        e.response == undefined ||
                        e.response.data == undefined
                    ) {
                        this.$message({
                            showClose: true,
                            message: e,
                            type: "error",
                            duration: 5000,
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: e.response.data,
                            type: "error",
                            duration: 5000,
                        });
                    }
                });
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        },
        search() {
            let tmp = this.kw;
            this.$router.push("/search/searchMovie?kw=" + tmp);
            this.kw = "";
        },
        async handleCommand(command) {
            if (command === "logout") {
                try {
                    // 调用后端接口清除服务端缓存
                    await axios.post('sysUser/logout');
                } catch (e) {
                    console.warn('退出登录接口调用失败:', e.message);
                }
                window.sessionStorage.clear();
                return this.$router.push("/login");
            }
            this.$router.push("/" + command);
        },
        toWelcome() {
            this.$router.push("/welcome");
        },
    },
};
</script>

<style scoped>
.el-header {
    height: 80px !important;
    border-bottom: 1px solid #e6e6e6;
}

.header-inner {
    width: 100%;
    margin: 0;
    padding: 0 32px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
    min-height: 80px;
}

.brand-link {
    display: flex;
    align-items: center;
    gap: 8px;
    color: black;
    font-size: 26px;
    white-space: nowrap;
    line-height: 1;
}

.brand-logo {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.logo {
    height: 80px;
    width: 200px;
}

.nav-menu {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-bottom: 0px solid #eee !important;
    height: 60px;
    margin: 0;
    min-width: max-content;
}

.el-menu-item {
    font-size: 20px;
}

.el-menu-item:hover {
    color: red !important;
}

.searchContainer {
    margin-left: auto;
    width: 250px;
    padding: 0;
    display: flex;
    align-items: center;
    flex: 0 1 250px;
}

.searchBar {
    width: 100%;
}

.searchBar >>> input {
    border-radius: 50px;
}

#searchBtn {
    transform: translate(-100%, 0);
}

.user-dropdown {
    flex-shrink: 0;
}

.el-dropdown-link {
    width: auto;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
}

.icon-arrow {
    transition: all 0.2s ease-in-out;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
}

.el-dropdown-link:hover .icon-arrow {
    /* 定义动画的状态 */
    -webkit-transform: rotate(180deg) scale(1);
    -moz-transform: rotate(180deg) scale(1);
    -o-transform: rotate(180deg) scale(1);
    -transform: rotate(180deg) scale(1);
}

.footer-mini {
    border-top: 1px solid #eee;
    padding-top: 20px;
    text-align: center;
}

.footer {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.el-main {
    padding: 0px;
}

@media (max-width: 1023px) {
    .header-inner {
        padding: 0 24px;
    }
}

@media (max-width: 768px) {
    #app.is-mobile-layout .welcome-shell .el-header {
        height: auto !important;
    }

    #app.is-mobile-layout .welcome-shell .header-inner {
        padding: 12px 16px;
        flex-wrap: wrap;
        align-items: center;
        gap: 12px;
    }

    #app.is-mobile-layout .welcome-shell .brand-link {
        font-size: 22px;
    }

    #app.is-mobile-layout .welcome-shell .nav-menu {
        order: 4;
        position: static;
        left: auto;
        top: auto;
        transform: none;
        width: 100%;
        margin: 0;
        display: flex;
        justify-content: center;
        height: auto;
        overflow-x: auto;
        min-width: 0;
    }

    #app.is-mobile-layout .welcome-shell .el-menu-item {
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        padding: 0 18px;
    }

    #app.is-mobile-layout .welcome-shell .searchContainer {
        order: 3;
        width: 100%;
        max-width: 360px;
        margin: 0 auto;
        padding: 0;
        justify-content: center;
        flex: 1 1 100%;
    }

    #app.is-mobile-layout .welcome-shell .searchBar {
        flex: 1;
    }

    #app.is-mobile-layout .welcome-shell .searchBar >>> input {
        height: 42px;
    }

    #app.is-mobile-layout .welcome-shell .user-dropdown {
        order: 2;
        margin-left: auto;
        flex-shrink: 0;
    }

    #app.is-mobile-layout .welcome-shell .el-dropdown-link {
        width: auto;
        margin: 0;
        flex-shrink: 0;
    }
}
</style>
